import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {OmapiEds} from '../../model/omapi-eds';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';

@Injectable()
export class EdsIdMapperService {
  public static omapiEdsLegacyUrl = '/assets/omapi/omapi-eds-legacy.json';
  public static omapiEdsDwnUrl = '/assets/omapi/omapi-eds-dwn.json';

  constructor(private httpClient: HttpClient) {
  }

  public getByOmapiId(omapiId: string): Observable<OmapiEds> {
    return this.httpClient.get<OmapiEds[]>(this.getCorrectEdsUrl())
      .pipe(
        map((data: OmapiEds[]) => {
          for (const item of data) {
            if (item.omapiId === omapiId) {
              return item;
            }
          }
          return null;
        })
      );
  }

  public mapEdsIdsToOmapiIds(edsIds: string[]): Observable<string[]> {
    return this.httpClient.get<OmapiEds[]>(this.getCorrectEdsUrl())
      .pipe(
        map((data: OmapiEds[]) => {
          const omapiIds: string[] = [];
          for (const item of data) {
            if (this.doesElementContainEdsId(item.edsIds, edsIds)) {
              omapiIds.push(item.omapiId);
            }
          }
          return omapiIds;
        })
      );
  }

  private doesElementContainEdsId(items: string[], edsIds: string[]): boolean {
    for (const id of edsIds) {
      if (items.includes(id)) {
        return true;
      }
    }
    return false;
  }

  private getCorrectEdsUrl(): string {
    if (OmapiIdsUtils.isLegacyUser()) {
      return EdsIdMapperService.omapiEdsLegacyUrl;
    } else {
      return EdsIdMapperService.omapiEdsDwnUrl;
    }
  }
}
